import Snowfall from "react-snowfall";

interface HolidaySnowProps {
	enabled?: boolean;
	snowflakeCount?: number;
	color?: string;
}

function isHolidaySeason(): boolean {
	const now = new Date();
	const month = now.getMonth();
	return month === 11; // December (0-indexed)
}

export function HolidaySnow({
	enabled = true,
	snowflakeCount = 150,
	color = "#ffffff",
}: HolidaySnowProps) {
	if (!enabled || !isHolidaySeason()) {
		return null;
	}

	return (
		<Snowfall
			snowflakeCount={snowflakeCount}
			color={color}
			style={{
				position: "fixed",
				width: "100vw",
				height: "100vh",
				zIndex: 9999,
				pointerEvents: "none",
			}}
		/>
	);
}
